import * as React from 'react';
import { Accordion, AccordionContent, AccordionHeader, AccordionItem, AccordionTitle, AnalyticsProvider, AnalyticsTrigger, Anchor, Autoscroll, Badge, Banner, BannerHeading, BannerItem, Button, Card, CardBottom, CardContent, CardFooter, CardHeader, CardTop, Collapse, CollapseLayer, CollapseLayerGrid, CollapseLayerProvider, CollapseProvider, CollapseToggle, CollapseTrigger, Container, Dropdown, EqualHeight, EqualHeightProvider, EuIcon, FeatureList, FeatureListItem, Fittext, Grid, GridCollapse, GridCollapseProvider, GridCollapseTrigger, GridColumn, HashTrigger, Heading, Icon, Image, InternetSpeed, Lightbox, LightboxProvider, LightboxTrigger, List, ListItem, Modal, ModalCloser, ModalProvider, ModalTrigger, Notice, ObjectFit, ProcessList, ProcessListItem, ProductCard, Section, SectionImage, Separator, ServiceCards, ServiceCardsItem, Table, TableCell, TableRow, Tag, Text, TextField, Tooltip, TooltipToggle, Video } from 'telia-front-react';
import ErrorUtil from '../util/ErrorUtil';
import ExtendedJsxParser from './ExtendedJsxParser';
class JsxRenderer extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "componentDidUpdate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (prevProps) => {
                if (this.props.jsx !== prevProps.jsx && this.state.errored) {
                    this.setState({ errored: false });
                }
            }
        });
        Object.defineProperty(this, "renderError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return (React.createElement(Container, null,
                    React.createElement(Separator, { spacing: "large", color: "invisible" }),
                    React.createElement(Notice, { type: "error" }, this.props.translate('general.error.message')),
                    React.createElement(Separator, { spacing: "large", color: "invisible" })));
            }
        });
        Object.defineProperty(this, "handleError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (e) => {
                this.setState({ errored: true });
                const jsxError = new Error(`JSX render failed on ${window.location.pathname}`);
                jsxError.stack = e.stack;
                ErrorUtil.pushErrorToTeliaRumAndLog(jsxError);
            }
        });
        this.state = { errored: false };
    }
    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.jsx !== this.props.jsx || this.state.errored !== nextState.errored;
    }
    componentDidMount() {
        if (this.props.doNotScroll !== true) {
            window.scrollTo(0, 0);
        }
    }
    render() {
        if (this.state.errored && this.props.showErrorNotice) {
            return this.renderError();
        }
        return (React.createElement(ExtendedJsxParser, { components: {
                Accordion,
                AccordionContent,
                AccordionHeader,
                AccordionItem,
                AccordionTitle,
                AnalyticsProvider,
                AnalyticsTrigger,
                Anchor,
                Autoscroll,
                Badge,
                Banner,
                BannerHeading,
                BannerItem,
                Button,
                Card,
                CardBottom,
                CardContent,
                CardFooter,
                CardHeader,
                CardTop,
                Collapse,
                CollapseLayer,
                CollapseLayerGrid,
                CollapseLayerProvider,
                CollapseProvider,
                CollapseToggle,
                CollapseTrigger,
                Container,
                Dropdown,
                EqualHeight,
                EqualHeightProvider,
                EuIcon,
                FeatureList,
                FeatureListItem,
                Fittext,
                Grid,
                GridCollapse,
                GridCollapseProvider,
                GridCollapseTrigger,
                GridColumn,
                HashTrigger,
                Heading,
                Icon,
                Image,
                InternetSpeed,
                Lightbox,
                LightboxProvider,
                LightboxTrigger,
                List,
                ListItem,
                Modal,
                ModalCloser,
                ModalProvider,
                ModalTrigger,
                Notice,
                ObjectFit,
                ProcessList,
                ProcessListItem,
                ProductCard,
                Section,
                SectionImage,
                Separator,
                ServiceCards,
                ServiceCardsItem,
                Table,
                TableCell,
                TableRow,
                Tag,
                Text,
                TextField,
                Tooltip,
                TooltipToggle,
                Video
            }, onError: this.handleError, showWarnings: this.props.env !== 'live', renderUnrecognized: (tagName) => this.props.env !== 'live' && React.createElement(Notice, { type: "error" },
                "Unknown component $",
                tagName), ...this.props, jsx: this.props.jsx }));
    }
}
export default JsxRenderer;
//# sourceMappingURL=JsxRenderer.js.map